import emoji from "emoji-dictionary"
import { fs } from "../controls/Constants"
import CodeArticle from "../components/CodeArticle"

const kariUtility = () => {
    const introduction= 
    `Utility functions in the kari namespace are essential tools designed to perform common, reusable tasks that simplify and enhance the functionality of your programs. 
    These functions provide convenient ways to handle specific operations that would otherwise require repetitive coding.
     By encapsulating these tasks into well-defined functions, utility functions promote code reusability, maintainability, and readability.
    `
    return (
    <>
        <section>
            <h1>{emoji.getUnicode("toolbox")} kariUtility Templates</h1>
            <h2>Introduction</h2>
            <p className={`text-formatter ${fs}`}>{introduction}</p>
        </section>  
        <section>
            <CodeArticle
            intro="Get Distance from kariUltrasonic"
            index="one"
            other={null}
            codeSignature={'template<typename T, typename U = float>\nU getDistance(T *accessClass);'}
            codeUsage={ `kariUltrasonic *ultra = new kariUltrasonic(8);\nfloat distance = getDistance(ultra);`}
            data={[
                "Designed to work with kariUltrasonic class or any kari class with a distance property.",
                `The function is to be mostly used when you have used measureMulti() method of kariUltrasonic<br/>
                and you are concerned to get the distance of a particular sensor for whatever reason
                `,
                `The function is to be used sparingly since kariUltrasonic handles all the logic for ultrasonic sensors<br/>
                 hence you barely need to get the distance measured by the <strong>kariUltrasonic</strong>.
                `,
                "However the method is still provided in case you wanted to based on your application and for debugging purposes.",
            ]}
            />
        </section> 
        <p className={fs}>{emoji.getUnicode("warning")} Only use this method when using more than one ultrasonic sensor otherwise use <span className="yellow">measure()</span> to get the distance.</p>
    </>
    )
}

export default kariUtility
